function getLocalCartKey(userId) {
  return `localCartItems_${userId}`;
}

function parseLocalCart(value) {
  try {
    const parsed = JSON.parse(value || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function getLocalCartItems(userId) {
  return parseLocalCart(localStorage.getItem(getLocalCartKey(userId)));
}

export function setLocalCartItems(userId, items) {
  localStorage.setItem(getLocalCartKey(userId), JSON.stringify(items));
}

export function addItemToLocalCart(userId, newItem) {
  const items = getLocalCartItems(userId);
  const colorHex = newItem?.color?.hex || "";
  const existingIndex = items.findIndex(
    (item) =>
      item.name === newItem.name &&
      item.size === newItem.size &&
      (item?.color?.hex || "") === colorHex
  );

  if (existingIndex >= 0) {
    items[existingIndex] = {
      ...items[existingIndex],
      quantity: (items[existingIndex].quantity || 1) + (newItem.quantity || 1),
    };
  } else {
    items.push({
      ...newItem,
      _id: `local_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
    });
  }

  setLocalCartItems(userId, items);
  return items;
}

export function removeItemFromLocalCart(userId, itemId) {
  const updated = getLocalCartItems(userId).filter((item) => item._id !== itemId);
  setLocalCartItems(userId, updated);
  return updated;
}

export function isLocalCartItemId(itemId) {
  return typeof itemId === "string" && itemId.startsWith("local_");
}
